import { combineReducers } from "redux"

import appReducer from "./app"
import crmReducer from "./crm"
import chargeReducer from "./charge"

const reducers = combineReducers({
  app: appReducer,
  crm: crmReducer,
  charge: chargeReducer,
})

export default reducers
